import {
  Badge,
  Box,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React from 'react';
import Activities from '../OwnerCard/Activities';
import Emails from '../OwnerCard/Emails';
import ChangeLog from '../OwnerCard/ChangeLog';
import { TabPanel } from '../OwnerCard/OwnerCard';
import { makeStyles, styled, useTheme } from '@mui/styles';
// import FeedbackAll from "./FeedbackAll";
import TaskpageFeedbackAll from './TaskPageFeedbackAll';

export const FeedbackDocumentation = ({
  proid,
  buyerId,
  notes,
  setNotes,
  handleUpdateNote,
  setValue,
  setIsEdit,
  setIsNoteEdit,
  isNoteEdit,
  loaderpart,
  sortedCategories,
  handleExpandCollapse,
  expandedCategories,
  setTaskToEdit,
  taskRefs,
  getTask,
  taskToEdit,
  selectedProperty,
  updateTaskScrollRef,
  value,
  setNoteToEdit,
  setTabValue,
  highlightKey,
  combinedData,
  noteToEdit,
  updateNoteScrollRef,
  handleDeleteNote,
  handleDeleteTask,
  ownercardprop,
  address,
}) => {
  const [propertyValue, setPropertyValue] = React.useState(0);

  const handlePropertyChange = (event, propertyValue) => {
    setPropertyValue(propertyValue);
  };

  const useStyles = makeStyles({
    tab: {
      minHeight: '26.19px', // Set the desired minimum height here
    },
  });

  const classes = useStyles();
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack
      sx={{
        background: '#FFFFFF',
        marginTop: '30px',
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: '100%',
          bgcolor: 'background.paper',
          color: '#585858 !important',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Tabs
          value={propertyValue}
          onChange={handlePropertyChange}
          sx={{
            '& .MuiTabs-indicator': { display: 'none' },
            '& .MuiTab-root.Mui-selected': {
              background: ' #e6d5f8',
              borderRadius: '5px',
              color: '#6d2ad1ff',
              gap: matchessm ? '5px' : '10px',
            },
            '& button.Mui-selected': {
              // minHeight: "24px",
              padding: '0px 10px',
            },
            '.MuiTab-root.Mui-selected::after': {
              backgroundColor: '#6d2ad1ff',
            },
            // marginLeft: "-11px",
            minHeight: '26.19px',
            bgcolor: '#f8f8f8',
            borderRadius: '5px',
          }}
        >
          <Tab
            style={{
              minHeight: '26.19px',
              padding: '0px',
              display: 'flex',
              gap: matchessm ? '5px' : '60px',
            }}
            className={classes.tab}
            label={
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: '500',
                  fontSize: matchessm ? '12px' : '16px',
                  textTransform: 'none',
                }}
              >
                All
              </Typography>
            }
          />
          <Tab
            style={{
              minHeight: '26.19px',
              padding: '0px',
              marginLeft: matchessm ? '5px' : '60px',
            }}
            className={classes.tab}
            label={
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px',
                  textTransform: 'none',
                }}
              >
                Notes
              </Typography>
            }
          />
          <Tab
            style={{
              minHeight: '26.19px',
              padding: '0px',
              marginLeft: matchessm ? '5px' : '60px',
            }}
            className={classes.tab}
            label={
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px',
                  textTransform: 'none',
                }}
              >
                Tasks
              </Typography>
            }
          />
        </Tabs>
      </Box>
      <TabPanel value={propertyValue} index={0}>
        <TaskpageFeedbackAll
          loaderpart={loaderpart}
          OwnerExpanded={true}
          combinedData={combinedData}
          noteToEdit={noteToEdit}
          setNoteToEdit={setNoteToEdit}
          setIsNoteEdit={setIsNoteEdit}
          updateNoteScrollRef={updateNoteScrollRef}
          updateTaskScrollRef={updateTaskScrollRef}
          setValue={setValue}
          value={value}
          setIsEdit={setIsEdit}
          isNoteEdit={isNoteEdit}
          taskToEdit={taskToEdit}
          setTaskToEdit={setTaskToEdit}
          handleDeleteNote={handleDeleteNote}
          handleDeleteTask={handleDeleteTask}
          address={address}
        />
      </TabPanel>
      <TabPanel value={propertyValue} index={1}>
        <Activities
          proid={proid}
          buyerId={buyerId}
          notes={notes}
          setNotes={setNotes}
          handleUpdateNote={handleUpdateNote}
          setNoteToEdit={setNoteToEdit}
          setIsNoteEdit={setIsNoteEdit}
          updateNoteScrollRef={updateNoteScrollRef}
          setValue={setValue}
          isNoteEdit={isNoteEdit}
          ownercardprop={ownercardprop}
          handleDeleteNote={handleDeleteNote}
        />
      </TabPanel>
      <TabPanel value={propertyValue} index={2}>
        <Emails
          loaderpart={loaderpart}
          sortedCategories={sortedCategories}
          handleExpandCollapse={handleExpandCollapse}
          expandedCategories={expandedCategories}
          buyerId={buyerId}
          setTaskToEdit={setTaskToEdit}
          taskRefs={taskRefs}
          getTask={getTask}
          setIsEdit={setIsEdit}
          taskToEdit={taskToEdit}
          selectedProperty={selectedProperty}
          updateTaskScrollRef={updateTaskScrollRef}
          value={value}
          setValue={setValue}
          highlightKey={highlightKey}
        />
      </TabPanel>
      <TabPanel value={propertyValue} index={3}>
        <ChangeLog />
      </TabPanel>
    </Stack>
  );
};
